// tslint:disable:max-file-line-count
import { Button, ButtonTheme } from '@cian/button-component';
import { OutsideClick } from '@cian/outside-click-component';
import { Popup, PopupArrow } from '@cian/popup-component';
import { mergeStyles } from '@cian/utils';
import * as PropTypes from 'prop-types';
import * as React from 'react';

import { ILoginMotivationPopupAPI, LoginMotivationPopup } from '../../../common/components/login_motivation_popup';
import { Phone } from '../../../common/components/phone';
import { PushSubscription } from '../../../common/components/push_subscription';
import { IOfferHelper } from '../../../presenter';
import { IOffer } from '../../../types/offer';

import { ReportPopup } from '../../../common/components/menu//more/report_popup';
import { HideButton } from '../../../common/components/menu/hide_button';
import { LikeButton } from '../../../common/components/menu/like';
import { IMoreButtonTracking } from '../../../common/components/menu/more/tracking';

import { IButtonsTracking } from './tracking';

import { IABExperiment } from '@cian/api-models/monolith-python/cian-api/site/v1/get-ab-experiments';
import { IComplaintsHelpers } from '../../../types/complaints';

import * as styles from './index.css';

import { IUser } from '../../../types/user';
import { ICommercialCardAPI } from '../../../commercial-card';

export interface IButtonsProps {
  position: number;
  containerClassName?: string;
  buttonClassName?: string;
  dynamicButtonClassName?: string;
  isCallbackVisible?: boolean;
  isMapActive: boolean;
  isComplainOpen: boolean;
  isSimplified?: boolean;
  isPhoneHidden?: boolean;
  offer: IOffer;
  isSimilar: boolean;
  showPushNotification?: boolean;
  isHideOfferFetching?: boolean;
  isMoreInfoHidden?: boolean;

  complaintsHelpers: IComplaintsHelpers;

  onFavoriteChange(isFavorite: boolean): void;
  onComplainClose(): void;
  onCommentClick?(): void;
  onCallbackClick?(): void;
  onMapButtonClick?(): void;
  onHideFromPrintClicked?(): void;
  onIdenticalOffersClick?(): void;
}

export interface IButtonsAPI {
  onPopupMoreOpen(offerid: number): void;
  onPopupReportOpen(offerid: number): void;
  onPopupMoreClose(offerid: number): void;
  onPopupReportClose(offerid: number): void;
  onHideOffer(): void;
}

export interface IButtonsContext {
  api: {
    card: ICommercialCardAPI;
    buttons: IButtonsAPI;
    loginMotivationPopup: ILoginMotivationPopupAPI;
    tracking: IButtonsTracking & IMoreButtonTracking;
  };
  offerHelper: IOfferHelper;
  offer: IOffer;
  experiments: IABExperiment[];
  user: IUser;
}

export interface IButtonsState {
  isReportActive: boolean;
  isMorePopupOpen: boolean;
  isPushSubscriptionPopupOpen: boolean;
}

// Рендерит кнопки внизу карточки
/* istanbul ignore next */
export class Buttons extends React.Component<IButtonsProps, IButtonsState> {

  public context: IButtonsContext;

  public static contextTypes = {
    api: PropTypes.object,
    experiments: PropTypes.array,
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
    user: PropTypes.object,
  };

  public constructor(props: IButtonsProps) {
    super(props);

    this.state = {
      isMorePopupOpen: false,
      isPushSubscriptionPopupOpen: false,
      isReportActive: false,
    };
  }

  public componentWillUpdate(nextProps: IButtonsProps, nextState: IButtonsState) {
    const { tracking } = this.context.api;

    if (nextProps.isMapActive !== this.props.isMapActive
      && tracking.trackMapOpened && tracking.trackMapClosed) {
      if (nextProps.isMapActive) {
        tracking.trackMapOpened();
      } else {
        tracking.trackMapClosed();
      }
    }

    if (nextState.isMorePopupOpen !== this.state.isMorePopupOpen) {
      if (nextState.isMorePopupOpen) {
        this.context.api.buttons.onPopupMoreOpen(nextProps.offer.id);
      } else {
        this.context.api.buttons.onPopupMoreClose(nextProps.offer.id);
      }
    }

    if (nextState.isReportActive !== this.state.isReportActive) {
      if (nextState.isReportActive) {
        this.context.api.buttons.onPopupReportOpen(nextProps.offer.id);
      } else {
        this.context.api.buttons.onPopupReportClose(nextProps.offer.id);
      }
    }
  }

  public componentWillReceiveProps(nextProps: IButtonsProps) {
    if (!this.state.isReportActive && nextProps.isComplainOpen) {
      this.setState({
        isReportActive: nextProps.isComplainOpen,
      });
    }
  }

  public render() {

    const { containerClassName } = this.props;

    return (
      <div onClick={e => e.stopPropagation()} className={containerClassName || ''}>
        { this.renderPhoneButton() }
        { this.renderLikeButton() }
        { this.renderReport() }
        { this.renderIdenticalOffersButton() }
        { this.renderCallBack() }
        { this.renderMap() }
        { this.renderHideButton() }
        { this.renderMore() }
      </div>
    );
  }

  private handlePhoneOpen = () => {
    const { tracking, card } = this.context.api;

    if (tracking && tracking.trackPhoneOpened) {
      tracking.trackPhoneOpened();
    } else if (card && card.onPhoneOpened) {
      card.onPhoneOpened();
    }
  }

  protected handleFavoriteClick = (value: boolean) => {
    const { onFavoriteChange } = this.props;

    onFavoriteChange(value);

    this.setState({ isPushSubscriptionPopupOpen: value });
  }

  protected handleMoreClick = () => {
    this.setState({
      isMorePopupOpen: !this.state.isMorePopupOpen,
    });
  }

  protected handleMorePopupClose = () => {
    this.setState({
      isMorePopupOpen: false,
    });
  }

  private handleCallbackClick = () => {
    const onCallbackClick = this.props.onCallbackClick;

    if (onCallbackClick) {
      onCallbackClick();
    }
  }

  private handleMapButtonClick = () => {
    const onMapButtonClick = this.props.onMapButtonClick;

    if (onMapButtonClick) {
      onMapButtonClick();
    }
  }

  private handleHideFromPrintClick = () => {
    const onHideFromPrintClicked = this.props.onHideFromPrintClicked;
    const { tracking } = this.context.api;

    if (tracking && tracking.trackHidePrintButtonClick) {
      tracking.trackHidePrintButtonClick();
    }

    if (onHideFromPrintClicked) {
      onHideFromPrintClicked();
    }
  }

  protected renderPhoneButton() {
    if (this.props.isPhoneHidden) {
      return null;
    }
    const { offer, buttonClassName, isSimplified } = this.props;
    const phone = this.context.offerHelper.presenters.getPhone();

    return phone && (
      <div className={buttonClassName || ''}>
        <Phone
          isSimplified={isSimplified}
          workTimeInfo={offer.workTimeInfo}
          phones={[phone]}
          onPhoneOpened={this.handlePhoneOpen}
          offer={offer}
        />
      </div>
    );
  }

  protected renderReport() {
    const {
      buttonClassName,
      complaintsHelpers: {
        sendComplaintFeedback,
        statusChanger,
        complaintsFormStatus,
      },
    } = this.props;
    const { user } = this.context;
    const { isReportActive } = this.state;

    return (
      <div className={buttonClassName || ''}>
        <div title="Пожаловаться на объявление">
          <Button
            {...mergeStyles(
              styles['report-button'],
              isReportActive && styles['button-active'],
              styles['report-button--big'],
            )}
            theme={ButtonTheme.Ghost}
            onClick={this.handleReportButtonClick}
          >
            Пожаловаться
          </Button>
        </div>
        {isReportActive && (
          <div {...mergeStyles(
            styles['popup-container'],
            styles['popup-container--big'],
          )}>
            <ReportPopup
              onClose={this.handleReportClose}
              sendComplaintFeedback={sendComplaintFeedback}
              complaintsFormStatus={complaintsFormStatus}
              statusChanger={statusChanger}
              userEmail={user && user.isAuthenticated ? user.email : ''}
            />
          </div>
        )}
      </div>
    );
  }

  protected renderCallBack() {
    const {buttonClassName, isCallbackVisible, dynamicButtonClassName} = this.props;

    return isCallbackVisible && (
      <div title="Перезвоните мне" className={buttonClassName || ''}>
        <Button
          {...mergeStyles(
            styles['callback-button'],
            this.isButtonHidden() && dynamicButtonClassName,
          )}
          theme={ButtonTheme.Ghost}
          onClick={this.handleCallbackClick}
        />
      </div>
    );
  }

  protected renderIdenticalOffersButton() {
    const { buttonClassName, onIdenticalOffersClick } = this.props;
    const { offer: { identicalOffers } } = this.context;

    if (!identicalOffers || !identicalOffers.items.length) {
      return null;
    }

    const { title, items } = identicalOffers;

    return (
      <div className={buttonClassName || ''} title={title}>
        <Button
          className={styles['identical-offers-button']}
          theme={ButtonTheme.Ghost}
          onClick={onIdenticalOffersClick}
        >
          <span className={styles['identical-offers-count']}>{items.length}</span>
          <span className={styles['identical-offers-title']}>{title}</span>
        </Button>
      </div>
    );
  }

  protected renderMore() {
    const { buttonClassName, dynamicButtonClassName } = this.props;
    const { isMorePopupOpen } = this.state;

    return (
      <div className={buttonClassName || ''}>
        <OutsideClick onOutsideClick={this.handleMorePopupClose}>
          <div title="Ещё">
            <Button
              {...mergeStyles(
                styles['more-button'],
                isMorePopupOpen && styles['button-active'],
                this.isButtonHidden() && dynamicButtonClassName,
              )}
              theme={ButtonTheme.Ghost}
              onClick={this.handleMoreClick}
            />
          </div>
          <div className={styles['popup-container']}>
            {isMorePopupOpen && this.renderMorePopup()}
          </div>
        </OutsideClick>
      </div>
    );
  }

  private handleDownloadPDFClick = () => {
    const { tracking } = this.context.api;

    if (tracking && tracking.trackPDFLinkClicked) {
      tracking.trackPDFLinkClicked();
    }
    this.handleMorePopupClose();
  }

  private handleDownloadDOCClick = () => {
    const { tracking } = this.context.api;

    if (tracking && tracking.trackDocLinkClicked) {
      tracking.trackDocLinkClicked();
    }
    this.handleMorePopupClose();
  }

  protected renderMap() {
    const {buttonClassName, isMapActive, dynamicButtonClassName} = this.props;
    const title = isMapActive ? 'Скрыть карту' : 'Показать на карте';

    return (
      <div title={title} className={buttonClassName || ''}>
        <Button
          {...mergeStyles(
            styles['map-button'],
            isMapActive && styles['button-active'],
            this.isButtonHidden() && dynamicButtonClassName,
          )}
          theme={ButtonTheme.Ghost}
          onClick={this.handleMapButtonClick}
        />
      </div>
    );
  }

  protected handleReportClose = () => {
    this.props.onComplainClose();

    this.setState({
      isReportActive: false,
    });
  }

  protected handleReportButtonClick = () => {
    const { tracking } = this.context.api;

    if (tracking && tracking.trackReportPopupOpened) {
      tracking.trackReportPopupOpened();
    }
    this.setState({
      isReportActive: true,
    });
  }

  protected renderLikeButton() {
    const { loginMotivationPopup } = this.context.api;
    const { offer, buttonClassName } = this.props;
    const { isPushSubscriptionPopupOpen } = this.state;

    return (
      <div
        {...mergeStyles([
          buttonClassName || '',
          styles['like-container'],
        ])}
      >
        <LikeButton
          isActive={!!offer.isFavorite}
          buttonClassName={styles['like-button']}
          toggleActivity={this.handleFavoriteClick}
        />
        <LoginMotivationPopup id={offer.id} {...loginMotivationPopup} />
        <PushSubscription isOpen={isPushSubscriptionPopupOpen} />
      </div>
    );
  }

  protected renderHideButton() {
    const { api: {buttons} } = this.context;
    const {buttonClassName, dynamicButtonClassName, isHideOfferFetching} = this.props;

    return (
      <div className={buttonClassName || ''}>
        <HideButton
          {...mergeStyles(this.isButtonHidden() && dynamicButtonClassName )}
          isFetching={isHideOfferFetching}
          hideOffer={buttons.onHideOffer}
        />
      </div>
    );
  }

  private handleCommentButtonClick = () => {
    const onCommentClick = this.props.onCommentClick;
    const { tracking } = this.context.api;

    if (tracking && tracking.trackAddCommentClick) {
      tracking.trackAddCommentClick();
    }

    if (onCommentClick) {
      onCommentClick();
    }

    this.handleMorePopupClose();
  }

  protected isButtonHidden() {
    const { isMorePopupOpen, isReportActive } = this.state;
    const { isMapActive } = this.props;

    return !isMorePopupOpen && !isReportActive && !isMapActive;
  }

  protected renderMorePopup() {
    const {offer} = this.props;

    return (
      <Popup containerStyle={[styles['more-popup']]} arrow={PopupArrow.RIGHT}>
        <ul className={styles['more-list']}>
          <li className={styles['more-item']}>
            <div onClick={this.handleCommentButtonClick}>
              Добавить комментарий
            </div>
          </li>
          <li className={styles['more-item']}>
            <div onClick={this.handleHideFromPrintClick}>Не показывать при печати</div>
          </li>
          <li className={styles['more-item']}>
            <a
              className={styles['more-link']}
              href={offer.fullUrl.replace('.ru/', '.ru/export/pdf/')}
              target="_blank"
              onClick={this.handleDownloadPDFClick}
            >
              Скачать PDF
            </a>
          </li>
          <li className={styles['more-item']}>
            <a
              className={styles['more-link']}
              href={offer.fullUrl.replace('.ru/', '.ru/export/docx/')}
              target="_blank"
              onClick={this.handleDownloadDOCClick}
            >
              Скачать DOC
            </a>
          </li>
        </ul>
      </Popup>
    );
  }
}
